import { ref } from 'vue';

export interface ToastItem {
    id: number;
    title: string;
    message?: string;
    variant: 'success' | 'warning' | 'danger';
    duration: number;
}

let nextId = 0;
const toasts = ref<ToastItem[]>([]);

function addToast(options: Omit<ToastItem, 'id'> & { duration?: number }): void {
    const id = nextId++;
    const item: ToastItem = {
        id,
        title: options.title,
        message: options.message,
        variant: options.variant ?? 'success',
        duration: options.duration ?? 4000,
    };
    toasts.value.push(item);
    setTimeout(() => removeToast(id), item.duration);
}

function removeToast(id: number): void {
    const idx = toasts.value.findIndex(t => t.id === id);
    if (idx !== -1) {
        toasts.value.splice(idx, 1);
    }
}

export function useToast(): {
    toasts: typeof toasts;
    addToast: typeof addToast;
    removeToast: typeof removeToast;
} {
    return { toasts, addToast, removeToast };
}
